import { render, staticRenderFns } from "./rums.vue?vue&type=template&id=4eab2b79&scoped=true&"
import script from "./rums.vue?vue&type=script&lang=js&"
export * from "./rums.vue?vue&type=script&lang=js&"
import style0 from "./rums.vue?vue&type=style&index=0&id=4eab2b79&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eab2b79",
  null
  
)

export default component.exports